export const CS_REGEX =  {
  username: /^(?:\d{10}|[\w\\.]+@\w+\.\w{2,})$/, // Regex for Username validation which can be Phone number or email address
  emailOrPhone: /^(?:\d{10}|[a-zA-Z0-9.!#$%&'*+\w/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.\w{2,4}?)+$)$/,
  email: /^([a-zA-Z0-9.!#$%&'*+\w/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.\w{2,4}?)+$)$/,
  price: /^-?(0|[1-9]\d*)?$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+.,/\w:;<=>?@\w[\\\]^_`{|}~-])(?=.{7,})/
}
